import { render, staticRenderFns } from "./VendorSignUp.vue?vue&type=template&id=65a7d122&"
import script from "./VendorSignUp.vue?vue&type=script&lang=js&"
export * from "./VendorSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports